import { Loader2 } from "lucide-react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import Cookies from "js-cookie";

export default function SsoCallbackPage() {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleCallback = () => {
      try {
        // Parse hash fragment
        const hash = location.hash.substring(1); // remove #
        const params = new URLSearchParams(hash);

        const token = params.get("token");
        const expiresAt = params.get("expires_at");
        const username = params.get("username");

        if (token) {
          // Calculate cookie expiration
          let cookieOptions: Cookies.CookieAttributes = { path: "/" };
          if (expiresAt) {
            cookieOptions.expires = new Date(parseInt(expiresAt) * 1000);
          }

          // Save to cookies
          Cookies.set("auth_token", token, cookieOptions);
          if (username) {
            Cookies.set("auth_username", username, cookieOptions);
          }

          // Redirect to dashboard
          navigate("/dosen/remunerasi", { replace: true });
        } else {
          console.error("No token found in SSO callback");
          navigate("/", { replace: true });
        }
      } catch (error) {
        console.error("Error processing SSO callback:", error);
        navigate("/", { replace: true });
      }
    };

    handleCallback();
  }, [location, navigate]);

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-background">
      <div className="flex flex-col items-center gap-4">
        <Loader2 className="size-10 text-primary animate-spin" />
        <div className="text-center">
          <h2 className="text-xl font-bold">Authenticating...</h2>
          <p className="text-muted-foreground text-sm">
            Please wait while we sync your session.
          </p>
        </div>
      </div>
    </div>
  );
}
